import { useQuery } from "@tanstack/react-query";

import { appQueriesStore } from "../api/queries";

export const usePortalUser = () => {
  return useQuery({ ...appQueriesStore.user, staleTime: Infinity });
};
